
export const app_version = process.env.REACT_APP_VERSION || '';
export const app_build = process.env.REACT_APP_BUILD || '';
export const version = `${app_version}.${app_build}`;
